export default __webpack_public_path__ + "static/media/rs-arte-12.540326c9.webp";